export default "__VITE_ASSET__CdCO1iM___"